const WORKLIST = 'WORKLIST';

export default {
	WORKLIST
};
